<template lang="pug">
  .component-reservation-list.row.column
    reservation-list-form(@filterReservations="setSearch", @searchReservations="setSearch")
    //p(v-if = "timeFromSearch").text-center Data Report Range {{ timeFromSearch }} - {{ timeToSearch }}
    //cards(v-if="$acl('reservations-reports')" :data="parsedReports")
    base-list(:component="component", :dataLoader="dataLoader", :search="search", :searchRangeDataLoader="getReports", ref="list")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import ReservationListForm from 'components/structure/ui/filters/ReservationListForm'
import BaseList from './BaseList'
import HeaderColumns from 'components/structure/ui/HeaderColumns'
import {mapState} from 'vuex'

export default {
  name: 'ReservationList',
  components: {
    HeaderColumns,
    ReservationListForm,
    BaseList
  },
  data() {
    return {
      component: require('components/backoffice/Reservation'),
      headers: ['', 'Reservation', 'Vehicle', 'Start', 'End', 'B.mode', 'Distance', 'Time', 'Cost', 'Status'],
      search: null,
      timeToSearch: null,
      timeFromSearch: null
    }
  },
  methods: {
    setSearch(search) {
      this.search = search
      this.$refs.list.debouncedLoader()
    },
    dataLoader(callback, page, resultsPerPage, search) {
      if (search && search.query) {
        KeplerBackofficeSdk.reservations.list(page, resultsPerPage, search).search((data) => {
          callback(data)
        })
        return
      }
      KeplerBackofficeSdk.reservations.list(page, resultsPerPage, search).all((data) => {
        callback(data)
      })
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ReservationList.vue?3b3e060e